import {
  BaseEquipment,
  BROOKVALE_ACCOUNTID,
  BRYTE_PLAN_ID_FOR_USER_CREATION,
  FB_PLATFORM_ACCOUNTID,
  FREE_TRIAL_PLAN_ID,
  GROWTHPOINT_PLAN_ID_FOR_USER_CREATION,
  HOME_ELITE_SA_PLAN_ID_FOR_USER_CREATION,
  IMMERSE_ACCOUNTID,
  JNJ_PLAN_ID_FOR_USER_CREATION,
  JUICEPLUS_HOME_ACCOUNTID,
  PRIMEDIA_PLAN_ID_FOR_USER_CREATION,
  TimeSlotType,
  UW_PLAN_ID_FOR_USER_CREATION,
} from 'fitbeat.models';
import { Equipment, Gym, GymEnvironment, GymTypeConfig, GymTypes, HOME_ACCOUNTID,
  SUSSEX_ACCOUNTID } from 'fitbeat.models';
import { Organisation } from 'fitbeat.models';
import {
  ENTELECT_PLAN_ID_FOR_USER_CREATION,
  GO_SMART_WELLNESS_PLAN_ID_FOR_USER_CREATION,
  IMMERSE_PLAN_ID_FOR_USER_CREATION,
  JUICE_PLUS_PLAN_ID_FOR_USER_CREATION,
  MK_WELLNESS_PLAN_ID_FOR_USER_CREATION,
  WALTONS_PLAN_ID_FOR_USER_CREATION,
  PLATFORM_PLAN_ID_FOR_USER_CREATION,
} from 'fitbeat.models';
import { BigBodyGroup, CardioOrResistance, Level } from '../entities/exercise';
import { WorkoutSettings } from '../entities/user/workoutsettings';
import { WorkoutType } from './workouttype';

export interface IGymTypeConfigWorkoutSettings extends GymTypeConfig {
  getAmountOfStations(gym: Gym): number;
  getWorkoutSettings(
    level: Level,
    cardioOrResistance: CardioOrResistance,
    ): WorkoutSettings[];
  getWorkoutSettingsForBalance(
    level: Level): WorkoutSettings[];
}

export interface IGymConfig {
  [GymTypes: string]: IGymTypeConfigWorkoutSettings;
}

export const GymConfigs: IGymConfig = {
  [GymTypes.Outdoor]: {
    allowedZones: [21, 22, 23, 24, 25, 26, 27, 28, 29, 30],
    getWorkoutSettings: (level, cardioOrResistance) => {
      return buildWorkoutSettings(level, cardioOrResistance, false);
    },
    getWorkoutSettingsForBalance: (level) => {
      return [];
    },
    getAmountOfStations(gym: Gym) { return gym.numOfZones * 2; },
    allowedWorkoutTypes: [
      WorkoutType.MediumStudioWorkout,
      WorkoutType.FullStudioWorkout,
    ],
  },
  [GymTypes.Indoor]: {
    allowedZones: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23],
    getWorkoutSettings: (level, cardioOrResistance) => {
      return [
        ...buildWorkoutSettings(level, cardioOrResistance, true),
        ...buildWorkoutSettings(level, cardioOrResistance, false),
      ];
    },
    getWorkoutSettingsForBalance: (level) => {
      return [
        new WorkoutSettings({
          level,
          allowBagContact: false,
          cardioOrResistance: CardioOrResistance.Balance,
          threeBodyGroups: [BigBodyGroup.Lower, BigBodyGroup.BackAndArms, BigBodyGroup.Upper],
          equipment: undefined,
        })];
    },
    getAmountOfStations(gym: Gym) { return gym.numOfZones * 2; },
    allowedWorkoutTypes: [
      WorkoutType.MediumStudioWorkout,
      WorkoutType.FullStudioWorkout,
    ],
  },
  [GymTypes.Elite]: {
    allowedZones: [31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46],
    getWorkoutSettingsForBalance: (level) => {
      return [];
    },
    getWorkoutSettings: (level, cardioOrResistance) => {
      return [

        new WorkoutSettings({
          level,
          allowBagContact: false,
          cardioOrResistance,
          threeBodyGroups: [BigBodyGroup.Lower, BigBodyGroup.BackAndArms, BigBodyGroup.Upper],
          equipment: BaseEquipment.getEliteBenchAndDumbells(),
        }),
        new WorkoutSettings({
          level,
          allowBagContact: false,
          cardioOrResistance,
          threeBodyGroups: [BigBodyGroup.Lower],
          equipment: BaseEquipment.getEliteBenchAndDumbells(),
        }),
        new WorkoutSettings({
          level,
          allowBagContact: false,
          cardioOrResistance,
          threeBodyGroups: [BigBodyGroup.Upper],
          equipment: BaseEquipment.getEliteBenchAndDumbells(),
        }),
        new WorkoutSettings({
          level,
          allowBagContact: false,
          cardioOrResistance,
          threeBodyGroups: [BigBodyGroup.BackAndArms],
          equipment: BaseEquipment.getEliteBenchAndDumbells(),
        }),

        new WorkoutSettings({
          level,
          allowBagContact: false,
          cardioOrResistance,
          threeBodyGroups: [BigBodyGroup.Lower, BigBodyGroup.BackAndArms, BigBodyGroup.Upper],
          equipment: BaseEquipment.getEliteBenchAndBands(),
        }),
        new WorkoutSettings({
          level,
          allowBagContact: false,
          cardioOrResistance,
          threeBodyGroups: [BigBodyGroup.Lower],
          equipment: BaseEquipment.getEliteBenchAndBands(),
        }),
        new WorkoutSettings({
          level,
          allowBagContact: false,
          cardioOrResistance,
          threeBodyGroups: [BigBodyGroup.Upper],
          equipment: BaseEquipment.getEliteBenchAndBands(),
        }),
        new WorkoutSettings({
          level,
          allowBagContact: false,
          cardioOrResistance,
          threeBodyGroups: [BigBodyGroup.BackAndArms],
          equipment: BaseEquipment.getEliteBenchAndBands(),
        }),

        new WorkoutSettings({
          level,
          allowBagContact: false,
          cardioOrResistance,
          threeBodyGroups: [BigBodyGroup.Lower, BigBodyGroup.BackAndArms, BigBodyGroup.Upper],
          equipment: BaseEquipment.getEliteBenchAndBandsAndDumbbells(),
        }),
        new WorkoutSettings({
          level,
          allowBagContact: false,
          cardioOrResistance,
          threeBodyGroups: [BigBodyGroup.Lower],
          equipment: BaseEquipment.getEliteBenchAndBandsAndDumbbells(),
        }),
        new WorkoutSettings({
          level,
          allowBagContact: false,
          cardioOrResistance,
          threeBodyGroups: [BigBodyGroup.Upper],
          equipment: BaseEquipment.getEliteBenchAndBandsAndDumbbells(),
        }),
        new WorkoutSettings({
          level,
          allowBagContact: false,
          cardioOrResistance,
          threeBodyGroups: [BigBodyGroup.BackAndArms],
          equipment: BaseEquipment.getEliteBenchAndBandsAndDumbbells(),
        }),
      ];
    },
    getAmountOfStations(gym: Gym) { return gym.numOfZones * 2; },
    allowedWorkoutTypes: [WorkoutType.QuickHomeOrStaticCardioWorkout, WorkoutType.MediumHomeOrStaticCardioWorkout,
      WorkoutType.FullHomeOrStaticCardioWorkout, WorkoutType.ExtraLongHomeOrStaticCardioWorkout],
  },
  [GymTypes.Home]: {
    allowedZones: [31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46],
    getWorkoutSettingsForBalance: (level) => {
      return [
        new WorkoutSettings({
          level,
          allowBagContact: false,
          cardioOrResistance: CardioOrResistance.Balance,
          threeBodyGroups: [BigBodyGroup.Lower, BigBodyGroup.BackAndArms, BigBodyGroup.Upper],
          equipment: BaseEquipment.getBodyWeight(),
        }),
        new WorkoutSettings({
          level,
          allowBagContact: false,
          cardioOrResistance: CardioOrResistance.Balance,
          threeBodyGroups: [BigBodyGroup.Lower, BigBodyGroup.BackAndArms, BigBodyGroup.Upper],
          equipment: BaseEquipment.getDumbbells(),
        }),
        new WorkoutSettings({
          level,
          allowBagContact: false,
          cardioOrResistance: CardioOrResistance.Balance,
          threeBodyGroups: [BigBodyGroup.Lower, BigBodyGroup.BackAndArms, BigBodyGroup.Upper],
          equipment: BaseEquipment.getEliteBenchAndDumbells(),
        })];
    },
    getWorkoutSettings: (level, cardioOrResistance) => {
      return [
        new WorkoutSettings({
          level,
          allowBagContact: false,
          cardioOrResistance,
          threeBodyGroups: [BigBodyGroup.Lower, BigBodyGroup.BackAndArms, BigBodyGroup.Upper],
          equipment: BaseEquipment.getBodyWeight(),
        }),

        new WorkoutSettings({
          level,
          allowBagContact: false,
          cardioOrResistance,
          threeBodyGroups: [BigBodyGroup.Lower, BigBodyGroup.BackAndArms, BigBodyGroup.Upper],
          equipment: BaseEquipment.getEliteBenchAndBands(),
        }),
        new WorkoutSettings({
          level,
          allowBagContact: false,
          cardioOrResistance,
          threeBodyGroups: [BigBodyGroup.Lower],
          equipment: BaseEquipment.getEliteBenchAndBands(),
        }),
        new WorkoutSettings({
          level,
          allowBagContact: false,
          cardioOrResistance,
          threeBodyGroups: [BigBodyGroup.Upper],
          equipment: BaseEquipment.getEliteBenchAndBands(),
        }),
        new WorkoutSettings({
          level,
          allowBagContact: false,
          cardioOrResistance,
          threeBodyGroups: [BigBodyGroup.BackAndArms],
          equipment: BaseEquipment.getEliteBenchAndBands(),
        }),

        new WorkoutSettings({
          level,
          allowBagContact: false,
          cardioOrResistance,
          threeBodyGroups: [BigBodyGroup.Lower, BigBodyGroup.BackAndArms, BigBodyGroup.Upper],
          equipment: BaseEquipment.getEliteBenchAndBandsAndDumbbells(),
        }),
        new WorkoutSettings({
          level,
          allowBagContact: false,
          cardioOrResistance,
          threeBodyGroups: [BigBodyGroup.Lower],
          equipment: BaseEquipment.getEliteBenchAndBandsAndDumbbells(),
        }),
        new WorkoutSettings({
          level,
          allowBagContact: false,
          cardioOrResistance,
          threeBodyGroups: [BigBodyGroup.Upper],
          equipment: BaseEquipment.getEliteBenchAndBandsAndDumbbells(),
        }),
        new WorkoutSettings({
          level,
          allowBagContact: false,
          cardioOrResistance,
          threeBodyGroups: [BigBodyGroup.BackAndArms],
          equipment: BaseEquipment.getEliteBenchAndBandsAndDumbbells(),
        }),

        new WorkoutSettings({
          level,
          allowBagContact: false,
          cardioOrResistance,
          threeBodyGroups: [BigBodyGroup.Lower, BigBodyGroup.BackAndArms, BigBodyGroup.Upper],
          equipment: BaseEquipment.getDumbbells(),
        }),
        new WorkoutSettings({
          level,
          allowBagContact: false,
          cardioOrResistance,
          threeBodyGroups: [BigBodyGroup.Lower],
          equipment: BaseEquipment.getDumbbells(),
        }),
        new WorkoutSettings({
          level,
          allowBagContact: false,
          cardioOrResistance,
          threeBodyGroups: [BigBodyGroup.Upper],
          equipment: BaseEquipment.getDumbbells(),
        }),
        new WorkoutSettings({
          level,
          allowBagContact: false,
          cardioOrResistance,
          threeBodyGroups: [BigBodyGroup.BackAndArms],
          equipment: BaseEquipment.getDumbbells(),
        }),

        new WorkoutSettings({
          level,
          allowBagContact: false,
          cardioOrResistance,
          threeBodyGroups: [BigBodyGroup.Lower, BigBodyGroup.BackAndArms, BigBodyGroup.Upper],
          equipment: BaseEquipment.getBenchAndDumbbells(),
        }),
        new WorkoutSettings({
          level,
          allowBagContact: false,
          cardioOrResistance,
          threeBodyGroups: [BigBodyGroup.Lower],
          equipment: BaseEquipment.getBenchAndDumbbells(),
        }),
        new WorkoutSettings({
          level,
          allowBagContact: false,
          cardioOrResistance,
          threeBodyGroups: [BigBodyGroup.Upper],
          equipment: BaseEquipment.getBenchAndDumbbells(),
        }),
        new WorkoutSettings({
          level,
          allowBagContact: false,
          cardioOrResistance,
          threeBodyGroups: [BigBodyGroup.BackAndArms],
          equipment: BaseEquipment.getBenchAndDumbbells(),
        }),
      ];
    },
    getAmountOfStations(gym: Gym) { return gym.numOfZones * 2; },
    allowedWorkoutTypes: [WorkoutType.QuickHomeOrStaticCardioWorkout, WorkoutType.MediumHomeOrStaticCardioWorkout,
      WorkoutType.FullHomeOrStaticCardioWorkout, WorkoutType.ExtraLongHomeOrStaticCardioWorkout],
  },
};

function buildWorkoutSettings(
  level: Level,
  cardioOrResistance: CardioOrResistance,
  allowBagContact: boolean,
  equipment?: Equipment[],
) {
  return [
    new WorkoutSettings({
      level,
      allowBagContact,
      cardioOrResistance,
      threeBodyGroups: [BigBodyGroup.Lower],
      equipment,
    }),
    new WorkoutSettings({
      level,
      allowBagContact,
      cardioOrResistance,
      threeBodyGroups: [BigBodyGroup.Upper],
      equipment,
    }),
    new WorkoutSettings({
      level,
      allowBagContact,
      cardioOrResistance,
      threeBodyGroups: [BigBodyGroup.BackAndArms],
      equipment,
    }),
    new WorkoutSettings({
      level,
      allowBagContact,
      cardioOrResistance,
      threeBodyGroups: [BigBodyGroup.Lower, BigBodyGroup.BackAndArms, BigBodyGroup.Upper],
      equipment,
    }),
  ];
}

const defaultHomeGym: Partial<Gym> = {
  type: GymTypes.Home,
  numOfZones: 12,
  autoCheckin: false,
  zoneMapping: [[31], [32], [33], [34], [35], [36], [37], [38], [39], [40],
    [41], [42], [43], [44], [45], [46], [47], [48], [49], [50]],
  publicHolidays: [],
  enabled: true,
};

// TODO: the apps load gyms from platform, but used in-app gym configs as well
// This should be in the db
// this is no longer exported here: use DbGymRepository
const gymConfig: { [key: string]: Gym } = {
// Prod:
  HomeAUS: new Gym({
    displayName: 'Home',
    organisation: Organisation.Fitillion,
    personalisedHeader: 'Fitillion App',
    shouldUseInAppPurchaseForMembership: true,
    landingPage: 'https://app.fitillion.com',
    name: 'HomeAUS',
    timezone: 'Australia/Sydney',
    accountId: HOME_ACCOUNTID,
    environment: GymEnvironment.Production,
    created: new Date('2023-01-01T00:00:00.000Z'),
    defaultHomeSignupFlow: true,
    dummyPriceIdForSignup: FREE_TRIAL_PLAN_ID,
    subscribeNewUsersToPlanAfterFirstOnboarding: {
      planId: 'price_1LWwRnGgqUDgVRX6jr0vcjLb',
    },
    ...defaultHomeGym,
  }),
  HomeDemo: new Gym({
    displayName: 'Home',
    organisation: Organisation.Fitillion,
    personalisedHeader: 'Fitillion App',
    shouldUseInAppPurchaseForMembership: true,
    landingPage: 'https://app.fitillion.com',
    name: 'HomeDemo',
    timezone: 'Australia/Sydney',
    accountId: HOME_ACCOUNTID,
    environment: GymEnvironment.Production,
    created: new Date('2025-04-09T00:00:00.000Z'),
    defaultHomeSignupFlow: true,
    dummyPriceIdForSignup: FREE_TRIAL_PLAN_ID,
    subscribeNewUsersToPlanAfterFirstOnboarding: {
      planId: 'price_1LWwRnGgqUDgVRX6jr0vcjLb',
    },
    ...defaultHomeGym,
  }),
  HomeEliteSA: new Gym({
    displayName: 'Home Elite South Africa',
    organisation: Organisation.Fitillion,
    personalisedHeader: 'Fitillion Elite',
    landingPage: 'https://studios.fitillion.com/setup-videos/',
    name: 'HomeEliteSA',
    timezone: 'Africa/Johannesburg',
    accountId: HOME_ACCOUNTID,
    environment: GymEnvironment.Production,
    defaultHomeSignupFlow: true,
    dummyPriceIdForSignup: HOME_ELITE_SA_PLAN_ID_FOR_USER_CREATION,
    created: new Date('2024-04-10T13:54:09.771Z'),
    ...defaultHomeGym,
  }),
  HomeTest: new Gym({
    displayName: 'Home Test Prod',
    organisation: Organisation.Test,
    personalisedHeader: 'Fitillion Test Home',
    shouldUseInAppPurchaseForMembership: true,
    landingPage: 'https://app.fitillion.com',
    name: 'HomeTest',
    timezone: 'Australia/Sydney',
    accountId: HOME_ACCOUNTID,
    environment: GymEnvironment.Production,
    created: new Date('2024-01-22T12:13:21.550Z'),
    defaultHomeSignupFlow: true,
    ...defaultHomeGym,
  }),
  HomeJuicePlus: new Gym({
    displayName: 'Juice Plus+',
    personalisedHeader: 'Juice Plus+ Wellness App',
    landingPage: 'https://juiceplus-au.fitillion.com',
    name: 'HomeJuicePlus',
    timezone: 'Australia/Sydney',
    environment: GymEnvironment.Production,
    accountId: JUICEPLUS_HOME_ACCOUNTID,
    organisation: Organisation.JuicePlus,
    email: 'info@juiceplus.fitillion.com',
    dummyPriceIdForSignup: JUICE_PLUS_PLAN_ID_FOR_USER_CREATION,
    allowedOnProductIds: [
      'prod_Os2Zzhnm8Sbaxz', // Standard Home Memberships
      'prod_OsTJD5qY7COUmv', // Trial plans
    ],
    subscribeNewUsersToPlanAfterFirstOnboarding: {
      planId: 'price_1O4iMrCsT0TSR8TmEhKdwHPy',
      coupon: 'vpSlLGfN',
    },
    ...defaultHomeGym,
  }),
  BrookvaleNSW: new Gym({
    displayName: 'Brookvale, NSW',
    name: 'BrookvaleNSW',
    organisation: Organisation.Brookvale,
    lastUpdated: new Date('2022-12-20T11:51:51.280Z'),
    type: GymTypes.Indoor,
    numOfZones: 18,
    timezone: 'Australia/Sydney',
    zoneMapping: [[19], [16], [1], [5], [18], [2], [13], [8], [11], [4], [10], [15], [6], [12], [14], [7], [3], [9]],
    autoCheckin: false,
    enableStudioAppCheckIn: true,
    publicHolidays: ['01-01',/* '04-07', '04-08', '04-09', '04-10', */
      // '04-25',: special hours for ANZAC day
      // '06-12',
      '12-25', '12-26'], // Setup according to NSW vacation days
    environment: GymEnvironment.Production,
    allowedOnProductIds:
    [
      'prod_MvU5o1JKmuJQjP',
      'prod_NJTPpBya9nFubN',
      `prod_NKZZ0p1IZ11tfa`,
      `prod_NKZVmnDa1EP6nK`,
      `prod_NKZOPY0ZL34tru`,
      `prod_NKZLKRGHopoPne`,
      'prod_NV2LcyiUN4Zagj',
      /* 12 Month Carbon 1$ */ 'prod_NKZZ0p1IZ11tfa',
      /* 6 Month Carbon 1$ */ 'prod_NKZVmnDa1EP6nK',
      /* 3 Month Carbon 1$ */ 'prod_NKZLKRGHopoPne',
      /* Standard Carbon 1$ */ 'prod_NKZOPY0ZL34tru',
      /* Pause plan */ 'prod_NK3CQ5dE69jEnZ',
      /* Free week */ 'prod_NK37hXpP5KM1p3',
      /* studio elite */ 'prod_OJ3fdk4tI4U53x',
    ],

    allowedCapacityAsPercentOfFullGym: 1,
    enabled: true,
    bagContactAllowed: true,
    accountId: BROOKVALE_ACCOUNTID,
    email: 'brookvale@fitillion.com.au',
    displayAddress: '34 Old Pittwater Rd, Brookvale',
    dummyPriceIdForSignup: 'brookvale-dummy-plan-id',
    websiteSlug: 'brookvale',
    subscribeNewUsersToPlanAfterFirstOnboarding: {
      planId: 'price_1OcMt5Ld8sv8uhTt6b8OQEzR', /* 1-week free trial */
      coupon: '0tgoubNg',
    },
    created: new Date('2023-01-01T00:00:00.000Z'),
    integrationsEnabled: ['ClassPass'],
    enableWebDemoBooking: true,
    enableStudioWeightRecommendations: true,
  }),
  SydneySussex: new Gym({
    displayName: 'Sydney CBD',
    name: 'SydneySussex',
    organisation: Organisation.FitillionPrivate,
    type: GymTypes.Indoor,
    numOfZones: 18,
    timezone: 'Australia/Sydney',
    zoneMapping: [[11], [16], [1], [4], [14], [8], [18], [9], [3], [2], [13], [7], [5], [10], [6], [12], [19], [15]],
    autoCheckin: false,
    publicHolidays: ['01-01', '01-26', '04-02', '04-03', '04-04', '04-05',
      '04-25',
      '06-14',
      '10-04', '12-25', '12-26', '12-27', '12-28'],
    environment: GymEnvironment.Production,
    allowedOnProductIds:
      ['prod_E1XV9DdQoXsOqs', 'prod_E1YDEd8lDgAsgl', 'prod_E1XuoW5GexIvtO',
        'prod_E1XkO4e48Ij23C', 'prod_E1XfNYBG8CCaFE', 'prod_JrXy4Osh2FDITE'],
    allowedCapacityAsPercentOfFullGym: 1,
    enabled: true,
    accountId: SUSSEX_ACCOUNTID,
    websiteSlug: 'sydneysussex',
    displayAddress: '22 Sussex St, Sydney',
    dummyPriceIdForSignup: FREE_TRIAL_PLAN_ID,
    created: new Date('2023-01-01T00:00:00.000Z'),
  }),
  FitillionSydneyOffice: new Gym({
    displayName: 'Fitillion Sydney Office',
    name: 'FitillionSydneyOffice',
    organisation: Organisation.FitillionPrivate,
    type: GymTypes.Indoor,
    numOfZones: 3 + (1 + 2 + 3),
    timezone: 'Australia/Sydney',
    zoneMapping: [[3,7,14,23], [5,11,21,23], [10,8,13,23],
      [100], [101], [101],
      [105], [106], [107], // static functional
    ],
    autoCheckin: false,
    enableStudioAppCheckIn: true,
    enableStudioWeightRecommendations: true,
    publicHolidays: [],
    environment: GymEnvironment.Production,
    allowedOnProductIds:
      ['prod_E1XV9DdQoXsOqs', 'prod_E1YDEd8lDgAsgl', 'prod_E1XuoW5GexIvtO',
        'prod_E1XkO4e48Ij23C', 'prod_E1XfNYBG8CCaFE', 'prod_JrXy4Osh2FDITE'],
    allowedCapacityAsPercentOfFullGym: 1,
    enabled: true,
    accountId: SUSSEX_ACCOUNTID,
    websiteSlug: 'fitillion-sydney-office',
    displayAddress: 'Fitillion Sydney Office',
    dummyPriceIdForSignup: FREE_TRIAL_PLAN_ID,
    created: new Date('2023-07-18T00:00:00.000Z'),
    landingPage: 'https://studios.fitillion.com/register?gymName=FitillionSydneyOffice',
  }),
  HomeSydneyOfficeAppWorkout: new Gym({
    displayName: 'Sydney Office App-Workout',
    organisation: Organisation.FitillionPrivate,
    shouldUseInAppPurchaseForMembership: true,
    personalisedHeader: 'Fitillion App',
    landingPage: 'https://studios.fitillion.com/register?gymName=FitillionSydneyOffice',
    name: 'HomeSydneyOfficeAppWorkout',
    timezone: 'Australia/Sydney',
    environment: GymEnvironment.Production,
    accountId: HOME_ACCOUNTID,
    created: new Date('2025-03-20T07:00:00.000Z'),
    defaultHomeSignupFlow: true,
    ...defaultHomeGym,
  }),
  FitillionMikesHouse: new Gym({
    displayName: 'Fitillion Mike\'s House',
    name: 'FitillionMikesHouse',
    organisation: Organisation.FitillionPrivate,
    type: GymTypes.Indoor,
    numOfZones: 4 + 2 + 5,
    timezone: 'Australia/Sydney',
    zoneMapping: [[3,7,14], [5,11,21], [10,8,13], [22,15,23],
      [106], [107], // static functional
      [100], [101], [102], [103], [104], // static cardio
    ],
    autoCheckin: false,
    enableStudioAppCheckIn: true,
    enableStudioWeightRecommendations: true,
    publicHolidays: [],
    environment: GymEnvironment.Production,
    allowedOnProductIds:
      ['prod_E1XV9DdQoXsOqs', 'prod_E1YDEd8lDgAsgl', 'prod_E1XuoW5GexIvtO',
        'prod_E1XkO4e48Ij23C', 'prod_E1XfNYBG8CCaFE', 'prod_JrXy4Osh2FDITE',
        'prod_LS4h99RWc1KExI' ],
    allowedCapacityAsPercentOfFullGym: 1,
    enabled: true,
    accountId: SUSSEX_ACCOUNTID,
    websiteSlug: 'fitillion-mikes-house',
    displayAddress: 'FitillionMikesHouse',
    dummyPriceIdForSignup: FREE_TRIAL_PLAN_ID,
    created: new Date('2023-07-18T00:00:00.000Z'),
    subscribeNewUsersToPlanAfterFirstOnboarding: {
      planId: 'price_1KlAXkCYhDMVLM8mg6T1dOJ6', // Elite A$ 0
      coupon: 'HbeuWLX1', // 100% off forever
    },
    singleStationPerZoneGym: true,
  }),
  CenturionProd: new Gym({
    displayName: 'Fitillion Centurion',
    name: 'CenturionProd',
    organisation: Organisation.FitillionPrivate,
    personalisedHeader: 'Fitillion Centurion',
    type: GymTypes.Indoor,
    numOfZones: 4 + (1 + 2 + 2 + 1 + 1 + 1 + 4),
    timezone: 'Africa/Johannesburg',
    zoneMapping: [ [22,15,23], [5,11,21], [10,8,13], [3,7,14],
      [102], [100], [100], [101], [101], [103], [104], [109],
      [105], [106], [107], [108], // static functional
    ],
    autoCheckin: false,
    enableStudioAppCheckIn: true,
    enableStudioWeightRecommendations: true,
    publicHolidays: [],
    environment: GymEnvironment.Production,
    allowedOnProductIds:
      ['prod_E1XV9DdQoXsOqs', 'prod_E1YDEd8lDgAsgl', 'prod_E1XuoW5GexIvtO',
        'prod_E1XkO4e48Ij23C', 'prod_E1XfNYBG8CCaFE', 'prod_JrXy4Osh2FDITE',
        'prod_LS4h99RWc1KExI'],
    allowedCapacityAsPercentOfFullGym: 1,
    enabled: true,
    accountId: SUSSEX_ACCOUNTID,
    websiteSlug: 'fitillion-centurion',
    displayAddress: 'FitillionCenturion',
    dummyPriceIdForSignup: FREE_TRIAL_PLAN_ID,
    created: new Date('2023-07-18T00:00:00.000Z'),
    subscribeNewUsersToPlanAfterFirstOnboarding: {
      planId: 'price_1KlAXkCYhDMVLM8mg6T1dOJ6', // Elite A$ 0
      coupon: 'HbeuWLX1', // 100% off forever
    },
    singleStationPerZoneGym: false,
  }),
  ImmerseGymsUK1: new Gym({
    displayName: 'Immerse',
    name: 'ImmerseGymsUK1',
    organisation: Organisation.ImmerseGymsUK,
    personalisedHeader: 'Immerse Gyms',
    type: GymTypes.Indoor,
    numOfZones: 6,
    timezone: 'Europe/London',
    zoneMapping: [[6, 23, 14], [3, 7, 14], [8, 10, 13], [5, 11, 21], [107], [108]], // 4z + calisthenics + boxing
    autoCheckin: false,
    enableStudioAppCheckIn: true,
    enableStudioWeightRecommendations: true,
    publicHolidays: [ // uk https://www.gov.uk/bank-holidays
      // all days are open, normal hours
    ],
    environment: GymEnvironment.Production,
    allowedOnProductIds: [],
    allowedCapacityAsPercentOfFullGym: 1,
    enabled: true,
    accountId: IMMERSE_ACCOUNTID,
    websiteSlug: 'immerse-uk-1',
    displayAddress: 'Immerse Gyms',
    dummyPriceIdForSignup: IMMERSE_PLAN_ID_FOR_USER_CREATION,
    created: new Date('2023-07-18T00:00:00.000Z'),
    subscribeNewUsersToPlanAfterFirstOnboarding: {
      planId: 'price_1P7EVGAA2YE9DeSl13xfDvrS',
      coupon: 'nq2kdPfG',
    },
    bagContactAllowed: false,
    usersWillExerciseInNextZoneAfterPause: true,
    email: 'team@immersegyms.co.uk',
    landingPage: 'https://fitillion.com/l/immerse',
    integrationsEnabled: ['Textmagic'],
    singleStationPerZoneGym: false,
  }),
  GrowthPointThePlaceSandton: new Gym({
    displayName: 'The Place, 1 Sandton Dr',
    name: 'GrowthPointThePlaceSandton',
    organisation: Organisation.GrowthPoint,
    type: GymTypes.Indoor,
    numOfZones: 5,
    timezone: 'Africa/Johannesburg',
    zoneMapping: [[3, 7], [6, 14], [5, 11], [10, 13], [22, 23]],
    publicHolidays: [
      '08-09', '09-24', '12-16', '12-25', '12-26',
    ],
    autoCheckin: false,
    enableStudioAppCheckIn: true,
    enableStudioWeightRecommendations: true,
    environment: GymEnvironment.Production,
    accountId: FB_PLATFORM_ACCOUNTID,
    allowedOnProductIds: ['prod_PVQ0oLfJhrjV2H'],
    allowedCapacityAsPercentOfFullGym: 1,
    enabled: true,
    displayAddress: 'The Place, 1 Sandton Dr',
    personalisedHeader : 'GrowthPoint Studio, The Place',
    bagContactAllowed: false,
    email: 'dmphela@growthpoint.co.za',
    integrationsEnabled: ['Textmagic'],
    landingPage: 'https://fitillion.com/l/growthpointtheplacesandton/',
    dummyPriceIdForSignup: GROWTHPOINT_PLAN_ID_FOR_USER_CREATION,
    subscribeNewUsersToPlanAfterFirstOnboarding: {
      planId: 'price_1QPkd5AcaWctOtVHIuJ01Kyc',
    },
    created: new Date('2024-07-18T11:22:21.741Z'),
  }),
  GrowthPointWoodlands: new Gym({
    displayName: 'Woodlands, Woodmead',
    name: 'GrowthPointWoodlands',
    organisation: Organisation.GrowthPoint,
    type: GymTypes.Indoor,
    numOfZones: 5,
    timezone: 'Africa/Johannesburg',
    zoneMapping: [[3, 7], [5, 11], [10, 13], [6, 14], [9, 23]],
    publicHolidays: [
      '08-09', '09-24', '12-16', '12-25', '12-26',
    ],
    autoCheckin: false,
    accountId: FB_PLATFORM_ACCOUNTID,
    allowedOnProductIds: ['prod_PVQ0oLfJhrjV2H'],
    enableStudioAppCheckIn: true,
    enableStudioWeightRecommendations: true,
    environment: GymEnvironment.Production,
    allowedCapacityAsPercentOfFullGym: 1,
    enabled: true,
    displayAddress: 'Woodlands, Woodmead',
    personalisedHeader : 'GrowthPoint Studio, Woodlands',
    bagContactAllowed: false,
    usersWillExerciseInNextZoneAfterPause: true,
    email: 'dmphela@growthpoint.co.za',
    integrationsEnabled: ['Textmagic'],
    landingPage: 'https://fitillion.com/l/growthpointwoodlands/',
    dummyPriceIdForSignup: GROWTHPOINT_PLAN_ID_FOR_USER_CREATION,
    subscribeNewUsersToPlanAfterFirstOnboarding: {
      planId: 'price_1QPkd5AcaWctOtVHIuJ01Kyc',
    },
    created: new Date('2024-07-18T11:22:21.741Z'),
  }),
// Staging:
  ImmerseGymsUK1Staging: new Gym({
    displayName: 'Immerse Staging',
    name: 'ImmerseGymsUK1Staging',
    organisation: Organisation.ImmerseGymsUK,
    personalisedHeader: 'Immerse Gyms Staging',
    type: GymTypes.Indoor,
    numOfZones: 6,
    timezone: 'Europe/London',
    zoneMapping: [[6, 23, 14], [3, 7, 14], [8, 10, 13], [5, 11, 21], [107], [108]], // 4z + calisthenics + boxing
    autoCheckin: false,
    enableStudioAppCheckIn: true,
    enableStudioWeightRecommendations: true,
    publicHolidays: [ // uk https://www.gov.uk/bank-holidays
      // all days are open, normal hours
    ],
    environment: GymEnvironment.Staging,
    allowedOnProductIds: [],
    allowedCapacityAsPercentOfFullGym: 1,
    enabled: true,
    accountId: IMMERSE_ACCOUNTID,
    websiteSlug: 'immerse-uk-staging-1',
    displayAddress: 'Immerse Gyms Staging',
    dummyPriceIdForSignup: IMMERSE_PLAN_ID_FOR_USER_CREATION,
    created: new Date('2024-02-28T00:00:00.000Z'),
    subscribeNewUsersToPlanAfterFirstOnboarding: {
      planId: 'price_1P7DyBAA2YE9DeSlUlF5nIPA',
      coupon: 'sNqsX62Q',
    },
    bagContactAllowed: false,
    usersWillExerciseInNextZoneAfterPause: true,
    email: 'team@immersegyms.co.uk',
    landingPage: 'https://staging.fitillion.com/register?gymName=ImmerseGymsUK1Staging&landingtest=true',
    integrationsEnabled: ['Textmagic'],
    singleStationPerZoneGym: false,
  }),
  HomeSA: new Gym({
    displayName: 'Home',
    organisation: Organisation.Fitillion,
    shouldUseInAppPurchaseForMembership: true,
    personalisedHeader: 'Fitillion App',
    landingPage: 'https://app-staging.fitillion.com',
    name: 'HomeSA',
    timezone: 'Africa/Johannesburg',
    environment: GymEnvironment.Staging,
    accountId: HOME_ACCOUNTID,
    created: new Date('2023-01-01T00:00:00.000Z'),
    defaultHomeSignupFlow: true,
    dummyPriceIdForSignup: FREE_TRIAL_PLAN_ID,
    subscribeNewUsersToPlanAfterFirstOnboarding: {
      planId: 'price_1LZ5SpGgqUDgVRX6lQS3hodJ',
    },
    ...defaultHomeGym,
  }),
  HomeEliteSAStaging: new Gym({
    displayName: 'Home Elite South Africa Staging',
    organisation: Organisation.Fitillion,
    personalisedHeader: 'Fitillion Elite Staging',
    dummyPriceIdForSignup: HOME_ELITE_SA_PLAN_ID_FOR_USER_CREATION,
    landingPage: 'https://staging.fitillion.com/register?gymName=HomeEliteSAStaging',
    name: 'HomeEliteSAStaging',
    timezone: 'Africa/Johannesburg',
    environment: GymEnvironment.Staging,
    accountId: HOME_ACCOUNTID,
    created: new Date('2024-04-10T13:54:09.771Z'),
    defaultHomeSignupFlow: true,
    ...defaultHomeGym,
  }),
  HomeOfficeScheduleTestGym: new Gym({
    displayName: 'Example Office Schedule',
    organisation: Organisation.FitillionPrivate,
    shouldUseInAppPurchaseForMembership: true,
    personalisedHeader: 'Fitillion App',
    landingPage: 'https://app-staging.fitillion.com',
    name: 'HomeOfficeScheduleTestGym',
    timezone: 'Africa/Johannesburg',
    environment: GymEnvironment.Staging,
    accountId: HOME_ACCOUNTID,
    created: new Date('2025-03-12T08:00:00.000Z'),
    defaultHomeSignupFlow: true,
    ...defaultHomeGym,
  }),
  HomeTestStaging: new Gym({
    displayName: 'Home Test Staging',
    organisation: Organisation.Test,
    shouldUseInAppPurchaseForMembership: true,
    personalisedHeader: 'Fitillion Home Test Gym',
    landingPage: 'https://app-staging.fitillion.com',
    name: 'HomeTestStaging',
    timezone: 'Africa/Johannesburg',
    environment: GymEnvironment.Staging,
    accountId: HOME_ACCOUNTID,
    created: new Date('2024-01-22T12:13:21.550Z'),
    defaultHomeSignupFlow: true,
    ...defaultHomeGym,
  }),
  HomeJuicePlusStaging: new Gym({
    displayName: 'Juice Plus+',
    personalisedHeader: 'Juice Plus+ Staging Wellness App',
    landingPage: 'https://staging.fitillion.com/register?gymName=HomeJuicePlusStaging',
    name: 'HomeJuicePlusStaging',
    timezone: 'Australia/Sydney',
    environment: GymEnvironment.Staging,
    accountId: JUICEPLUS_HOME_ACCOUNTID,
    organisation: Organisation.JuicePlus,
    dummyPriceIdForSignup: JUICE_PLUS_PLAN_ID_FOR_USER_CREATION,
    email: 'info@juiceplus.fitillion.com',
    allowedOnProductIds: [
      'prod_OlNgWSoc6ZOkER', // Standard Home Memberships
      'prod_OsSCvTGhbRLtrN', // Trial plans
    ],
    subscribeNewUsersToPlanAfterFirstOnboarding: {
      planId: 'price_1O4hIRCsT0TSR8Tm4YtxLnma',
      coupon: 'QicUrnCm',
    },
    ...defaultHomeGym,
  }),
  BrookvaleStaging: new Gym({
    displayName: 'Brookvale (staging)',
    name: 'BrookvaleStaging',
    organisation: Organisation.Brookvale,
    lastUpdated: new Date('2022-12-20T11:51:51.280Z'),
    type: GymTypes.Indoor,
    numOfZones: 18,
    timezone: 'Australia/Sydney',
    zoneMapping: [[19], [16], [1], [5], [18], [2], [13], [8], [11], [4], [10], [15], [6], [12], [14], [7], [3], [9]],
    autoCheckin: false,
    enableStudioAppCheckIn: true,
    publicHolidays: ['01-01',/* '04-07', '04-08', '04-09', '04-10', */
      // '04-25',: special hours for ANZAC day
      // '06-12',
      '12-25', '12-26'], // Setup according to NSW vacation days
    environment: GymEnvironment.Staging,
    allowedOnProductIds:
      [
        'prod_MtDKJtnge78aUG',
        'prod_NJj15pksSqwyzg',
        'prod_NWPLigMp9x4YqY',
        /* Free week */ 'prod_NZUl40Nr0TjaB9',
        /* Pause plan */ 'prod_NZUpd1jqfkpZRj'],
    allowedCapacityAsPercentOfFullGym: 1,
    enabled: true,
    accountId: BROOKVALE_ACCOUNTID,
    displayAddress: '34 Old Pittwater Rd, Brookvale',
    dummyPriceIdForSignup: 'brookvale-dummy-plan-id',
    websiteSlug: 'brookvale',
    subscribeNewUsersToPlanAfterFirstOnboarding: {
      planId: 'price_1OcMocLd8sv8uhTtXcj85fTG', /* 1-week free trial */
      coupon: 'VvpgXPlc',
    },
    created: new Date('2023-01-01T00:00:00.000Z'),
    integrationsEnabled: ['ClassPass'],
    enableWebDemoBooking: true,
    bagContactAllowed: true,
  }),
  GrowthPointThePlaceSandtonStaging: new Gym({
    displayName: 'The Place, 1 Sandton Dr Staging',
    name: 'GrowthPointThePlaceSandtonStaging',
    organisation: Organisation.GrowthPoint,
    type: GymTypes.Indoor,
    landingPage: 'https://staging.fitillion.com/register?gymName=GrowthPointThePlaceSandtonStaging',
    numOfZones: 5,
    timezone: 'Africa/Johannesburg',
    zoneMapping: [[3, 7], [6, 14], [5, 11], [10, 13], [22, 23]],
    publicHolidays: [
      '2024-03-29', '2024-06-17', // 2024 specific
      '01-01', '03-21', '04-27', '05-01',
      '06-16', '08-09', '09-24', '12-16', '12-25', '12-26',
    ],
    autoCheckin: false,
    enableStudioAppCheckIn: true,
    enableStudioWeightRecommendations: true,
    environment: GymEnvironment.Staging,
    accountId: FB_PLATFORM_ACCOUNTID,
    allowedOnProductIds: ['prod_PVlwZ7ocLayt09'],
    allowedCapacityAsPercentOfFullGym: 1,
    enabled: true,
    displayAddress: 'The Place, 1 Sandton Dr staging',
    personalisedHeader: 'GrowthPoint Studio, The Place staging',
    bagContactAllowed: false,
    email: 'dmphela@growthpoint.co.za',
    integrationsEnabled: ['MessageBird'],
    dummyPriceIdForSignup: GROWTHPOINT_PLAN_ID_FOR_USER_CREATION,
    subscribeNewUsersToPlanAfterFirstOnboarding: {
      planId: 'price_1QPij1AcaWctOtVHoG3M0Iao',
    },
    created: new Date('2024-07-18T11:22:21.741Z'),
  }),
  Centurion: new Gym({
    displayName: 'Centurion',
    name: 'Centurion',
    organisation: Organisation.FitillionPrivate,
    personalisedHeader: 'Fitillion Centurion Staging',
    type: GymTypes.Indoor,
    numOfZones: 4 + (3 + 1 + 1 + 1 + 1 + 1 + 1 + 1 + 1 + 1),
    autoCheckin: false,
    enableStudioAppCheckIn: true,
    enableStudioWeightRecommendations: true,
    timezone: 'Africa/Johannesburg',
    enableWebDemoBooking: false,
    landingPage: 'https://fitillion.com/l/CenturionStaging/',
    zoneMapping: [
      // also check platform tests when changing areas
      [22,15,23], [5,11,21], [10,8,13],
      [3,7,14],
      [100], [100], [100], [101], [102], [103], [104], [109],
      [105], [106], // it normally would only be either 105 or 106, but add both for testing
      [107], [108],
    ],
    publicHolidays: ['01-01', '03-21', '05-01',
    '08-09', '09-24', '12-16', '12-25', '12-26'],
    environment: GymEnvironment.Staging,
    allowedOnProductIds:
      ['prod_E1QECsbrsCKG1f', 'prod_E1QEK10BMpWq3v', 'prod_E1QBXuwJvjHzPX',
        'prod_E1Q6HRAOEjS0ik', 'prod_E1Q6Q4JtH1AFbR', 'prod_JqmSqXfKYpEfyB',
        'prod_NKAdYCL2f34VNV', 'prod_LQA4eliQXyAEo4',
      ],
    allowedCapacityAsPercentOfFullGym: 1,
    enabled: true,
    displayAddress: 'Unit 3 Jurg Business Park',
    accountId: SUSSEX_ACCOUNTID,
    email: 'centurion.studio@fitillion.com',
    dummyPriceIdForSignup: FREE_TRIAL_PLAN_ID,
    websiteSlug: 'centurion',
    subscribeNewUsersToPlanAfterFirstOnboarding: {
      planId: 'price_1PzcebCYhDMVLM8mPuj41Fik',
    },
    allowUpdatingSubscriptionInSelfManagementPortal: true,
    created: new Date('2023-01-01T00:00:00.000Z'),
    integrationsEnabled: ['ClassPass', 'Textmagic'],
    singleStationPerZoneGym: false,
    displayInstructorContentForTimeSlots: [TimeSlotType.Peak],
    instructorLessTimeSlotDescription: {
      [TimeSlotType.Peak]: 'Premium',
      [TimeSlotType.OffPeak]: 'Freemium',
    },
  }),
  Staging3Zone: new Gym({
    displayName: 'Staging3Zone',
    name: 'Staging3Zone',
    organisation: Organisation.Fitillion,
    type: GymTypes.Indoor,
    numOfZones: 3,
    autoCheckin: false,
    enableStudioAppCheckIn: true,
    enableStudioWeightRecommendations: true,
    enableWebDemoBooking: false,
    timezone: 'Africa/Johannesburg',
    zoneMapping: [[3,7,14,23], [5,11,21,23], [10,8,13,23]],
    publicHolidays: [],
    environment: GymEnvironment.Staging,
    allowedOnProductIds:
      ['prod_E1QECsbrsCKG1f', 'prod_E1QEK10BMpWq3v', 'prod_E1QBXuwJvjHzPX',
        'prod_E1Q6HRAOEjS0ik', 'prod_E1Q6Q4JtH1AFbR', 'prod_JqmSqXfKYpEfyB',
        'prod_NKAdYCL2f34VNV', 'prod_LQA4eliQXyAEo4',
      ],
    allowedCapacityAsPercentOfFullGym: 1,
    enabled: true,
    displayAddress: 'Jacques house',
    accountId: SUSSEX_ACCOUNTID,
    email: 'centurion.studio@fitillion.com',
    dummyPriceIdForSignup: FREE_TRIAL_PLAN_ID,
    websiteSlug: 'staging-3-zone',
    bagContactAllowed: true,
    subscribeNewUsersToPlanAfterFirstOnboarding: {
      planId: 'price_1KnPDTCYhDMVLM8mCSb15PMG', // Elite A$ 0
      coupon: 'Cy0INsrC', // 100% off forever
    },
    created: new Date('2023-07-18T00:00:00.000Z'),
  }),
  JohnsonAndJohnsonSydney: new Gym({
    name: 'JohnsonAndJohnsonSydney',
    displayName: 'Johnson & Johnson',
    personalisedHeader: 'Johnson & Johnson Wellness',
    landingPage: 'https://fitillion.com/l/jnj-sydney/',
    timezone: 'Australia/Sydney',
    environment: GymEnvironment.Production,
    accountId: FB_PLATFORM_ACCOUNTID,
    organisation: Organisation.JohnsonAndJohnson,
    email: '',
    dummyPriceIdForSignup: JNJ_PLAN_ID_FOR_USER_CREATION,
    subscribeNewUsersToPlanAfterFirstOnboarding: {
      planId: 'price_1RVs4PAcaWctOtVHdQxQhBb3',
    },
    allowedOnProductIds: ['prod_SQjXF6xeXv5HH5'],
    created: new Date('2024-05-23T00:00:00.000Z'),
    type: GymTypes.Indoor,
    numOfZones: 19,
    zoneMapping: [
      // circuit 10x
      [9], [18], [5], [6], [8], [14], [10], [15], [3], [20],
      // from door entrance, static machine block:
      [101], [101], [100], [100], // 2x bikes + 2x treadmills on right
      [103], [103], [103], // 3x ellipticals on left
      // walk through to static functional block
      [108], // 1x double zone boxing on left
      [106], // 1x double zone benchAndDumbbell on right
    ],
    autoCheckin: false,
    enableStudioAppCheckIn: true,
    enableStudioWeightRecommendations: true,
    publicHolidays: [
      // TODO
    ],
    allowedCapacityAsPercentOfFullGym: 1,
    enabled: true,
    bagContactAllowed: false,
    usersWillExerciseInNextZoneAfterPause: true,
    singleStationPerZoneGym: false,
  }),
  UnitedWellness: new Gym({ // home only
    name: 'UnitedWellness',
    displayName: 'United Wellness',
    personalisedHeader: 'United Wellness',
    landingPage: 'https://fitillion.com/l/knight-frank/',
    timezone: 'Australia/Sydney',
    environment: GymEnvironment.Production,
    accountId: FB_PLATFORM_ACCOUNTID,
    organisation: Organisation.KnightFrank,
    email: '',
    dummyPriceIdForSignup: UW_PLAN_ID_FOR_USER_CREATION,
    subscribeNewUsersToPlanAfterFirstOnboarding: {
      planId: 'price_1PTfsFAcaWctOtVHzdnbOrGo',
      coupon: '8rTceOno',
    },
    allowedOnProductIds: [],
    created: new Date('2024-06-20T00:00:00.000Z'),
    ...defaultHomeGym,
  }),

  GoSmartWellness: new Gym({ // home only
    name: 'GoSmartWellness',
    displayName: 'Go Smart Wellness',
    personalisedHeader: 'Go Smart Wellness',
    landingPage: 'https://fitillion.com/l/gosmarthr/',
    timezone: 'Africa/Johannesburg',
    environment: GymEnvironment.Production,
    accountId: FB_PLATFORM_ACCOUNTID,
    organisation: Organisation.GoSmartWellness,
    email: '',
    dummyPriceIdForSignup: GO_SMART_WELLNESS_PLAN_ID_FOR_USER_CREATION,
    subscribeNewUsersToPlanAfterFirstOnboarding: {
      planId: 'price_1PTfsFAcaWctOtVHzdnbOrGo',
      coupon: '8rTceOno',
    },
    allowedOnProductIds: [],
    created: new Date('2025-02-05T00:00:00.000Z'),
    ...defaultHomeGym,
  }),

  Entelect: new Gym({ // home only
    name: 'Entelect',
    displayName: 'Entelect',
    personalisedHeader: 'Entelect',
    landingPage: 'https://fitillion.com/l/entelect/',
    timezone: 'Africa/Johannesburg',
    environment: GymEnvironment.Production,
    accountId: FB_PLATFORM_ACCOUNTID,
    organisation: Organisation.Entelect,
    email: '',
    dummyPriceIdForSignup: ENTELECT_PLAN_ID_FOR_USER_CREATION,
    subscribeNewUsersToPlanAfterFirstOnboarding: {
      planId: 'price_1PTfsFAcaWctOtVHzdnbOrGo',
      coupon: '8rTceOno',
    },
    allowedOnProductIds: [],
    created: new Date('2025-02-14T00:00:00.000Z'),
    ...defaultHomeGym,
  }),
  PrimediaOutOfHome: new Gym({ // home only
    name: 'PrimediaOutOfHome',
    displayName: 'Primedia Out Of Home',
    personalisedHeader: 'Primedia Out Of Home',
    landingPage: 'https://fitillion.com/l/primedia-out-of-home/',
    timezone: 'Africa/Johannesburg',
    environment: GymEnvironment.Production,
    accountId: FB_PLATFORM_ACCOUNTID,
    organisation: Organisation.Primedia,
    email: '',
    dummyPriceIdForSignup: PRIMEDIA_PLAN_ID_FOR_USER_CREATION,
    subscribeNewUsersToPlanAfterFirstOnboarding: {
      planId: 'price_1PTfsFAcaWctOtVHzdnbOrGo',
      coupon: '8rTceOno',
    },
    allowedOnProductIds: [],
    created: new Date('2025-06-24T00:00:00.000Z'),
    ...defaultHomeGym,
  }),
  MKWellness: new Gym({ // home only
    name: 'MKWellness',
    displayName: 'MK Wellness',
    personalisedHeader: 'MK Wellness',
    landingPage: 'https://fitillion.com/l/mk-wellness/',
    timezone: 'Africa/Johannesburg',
    environment: GymEnvironment.Production,
    accountId: FB_PLATFORM_ACCOUNTID,
    organisation: Organisation.MKWellness,
    email: '',
    dummyPriceIdForSignup: MK_WELLNESS_PLAN_ID_FOR_USER_CREATION,
    subscribeNewUsersToPlanAfterFirstOnboarding: {
      planId: 'price_1PTfsFAcaWctOtVHzdnbOrGo',
      coupon: '8rTceOno',
    },
    allowedOnProductIds: [],
    created: new Date('2025-04-30T09:40:00.000Z'),
    ...defaultHomeGym,
  }),
  Bryte: new Gym({ // home only
    name: 'Bryte',
    displayName: 'Bryte',
    personalisedHeader: 'Bryte',
    landingPage: 'https://fitillion.com/l/bryte/',
    timezone: 'Africa/Johannesburg',
    environment: GymEnvironment.Production,
    accountId: FB_PLATFORM_ACCOUNTID,
    organisation: Organisation.Bryte,
    email: '',
    dummyPriceIdForSignup: BRYTE_PLAN_ID_FOR_USER_CREATION,
    subscribeNewUsersToPlanAfterFirstOnboarding: {
      planId: 'price_1PTfsFAcaWctOtVHzdnbOrGo',
      coupon: '8rTceOno',
    },
    allowedOnProductIds: [],
    created: new Date('2025-05-14T11:37:31.000Z'),
    ...defaultHomeGym,
  }),
  UnitedWellnessKnightFrankHQ: new Gym({
    name: 'UnitedWellnessKnightFrankHQ',
    displayName: 'United Wellness, 123 Pitt st',
    displayAddress: '123 Pitt st',
    personalisedHeader: 'United Wellness Knight Frank HQ',
    landingPage: 'https://fitillion.com/l/unite-wellness-knight-frank-hq-au/',
    email: '', // TODO: confirm
    organisation: Organisation.KnightFrank,
    environment: GymEnvironment.Production,
    type: GymTypes.Indoor,
    timezone: 'Australia/Sydney',
    numOfZones: 5, // TODO: confirm
    zoneMapping: [[3, 7], [5, 11], [10, 13], [12, 14], [9, 23]], // TODO confirm
    accountId: FB_PLATFORM_ACCOUNTID,
    allowedOnProductIds: ['prod_Q9nvAQVozYJanm'],
    dummyPriceIdForSignup: UW_PLAN_ID_FOR_USER_CREATION,
    subscribeNewUsersToPlanAfterFirstOnboarding: {
      planId: 'price_1PJUJBAcaWctOtVH1rdzqyjt',
      coupon: '8rTceOno',
    },
    autoCheckin: false,
    enableStudioAppCheckIn: true,
    enableStudioWeightRecommendations: true,
    allowedCapacityAsPercentOfFullGym: 1,
    bagContactAllowed: false,
    publicHolidays: ['01-01', '12-25', '12-26'],
    enabled: true,
    created: new Date('2024-08-16T08:33:00.000Z'),
  }),
  UnitedWellnessStaging: new Gym({ // home only
    name: 'UnitedWellnessStaging',
    displayName: 'United Wellness Staging',
    personalisedHeader: 'United Wellness Staging',
    landingPage: 'https://staging.fitillion.com/register?gymName=UnitedWellnessStaging&landingtest=true',
    timezone: 'Australia/Sydney',
    environment: GymEnvironment.Staging,
    accountId: FB_PLATFORM_ACCOUNTID,
    organisation: Organisation.KnightFrank,
    email: '',
    dummyPriceIdForSignup: UW_PLAN_ID_FOR_USER_CREATION,
    subscribeNewUsersToPlanAfterFirstOnboarding: {
      planId: 'price_1PTihhAcaWctOtVHYhbWs47p',
      coupon: 'OngKqtut',
    },
    allowedOnProductIds: [],
    created: new Date('2024-06-20T00:00:00.000Z'),
    ...defaultHomeGym,
  }),
  GoSmartWellnessStaging: new Gym({ // home only
    name: 'GoSmartWellnessStaging',
    displayName: 'Go Smart Wellness Staging',
    personalisedHeader: 'Go Smart Wellness Staging',
    landingPage: 'https://staging.fitillion.com/register?gymName=GoSmartWellnessStaging&landingtest=true',
    timezone: 'Africa/Johannesburg',
    environment: GymEnvironment.Staging,
    accountId: FB_PLATFORM_ACCOUNTID,
    organisation: Organisation.GoSmartWellness,
    email: '',
    dummyPriceIdForSignup: GO_SMART_WELLNESS_PLAN_ID_FOR_USER_CREATION,
    subscribeNewUsersToPlanAfterFirstOnboarding: {
      planId: 'price_1PTihhAcaWctOtVHYhbWs47p',
      coupon: 'OngKqtut',
    },
    allowedOnProductIds: [],
    created: new Date('2025-02-05T00:00:00.000Z'),
    ...defaultHomeGym,
  }),
  UnitedWellnessKnightFrankHQStaging: new Gym({
    name: 'UnitedWellnessKnightFrankHQStaging',
    displayName: 'United Wellness, 123 Pitt st',
    displayAddress: '123 Pitt st',
    personalisedHeader: 'United Wellness Knight Frank HQ',
    landingPage: '',
    email: '',
    organisation: Organisation.KnightFrank,
    environment: GymEnvironment.Staging,
    type: GymTypes.Indoor,
    timezone: 'Australia/Sydney',
    numOfZones: 5, // TODO: confirm
    zoneMapping: [[3, 7], [5, 11], [10, 13], [12, 14], [9, 23]], // TODO confirm
    accountId: FB_PLATFORM_ACCOUNTID,
    allowedOnProductIds: ['prod_PVlwZ7ocLayt09'],
    dummyPriceIdForSignup: UW_PLAN_ID_FOR_USER_CREATION,
    subscribeNewUsersToPlanAfterFirstOnboarding: {
      planId: 'price_1PoLxqAcaWctOtVHNUu5iLWQ', // Peak Price
      coupon: '8rTceOno',
    },
    autoCheckin: false,
    enableStudioAppCheckIn: true,
    enableStudioWeightRecommendations: true,
    allowedCapacityAsPercentOfFullGym: 1,
    bagContactAllowed: false,
    publicHolidays: ['01-01', '12-25', '12-26'],
    enabled: true,
    created: new Date('2024-08-16T08:33:00.000Z'),
  }),
  Waltons: new Gym({
    displayName: 'Waltons',
    personalisedHeader: 'Bidvest Waltons',
    landingPage: '',
    name: 'Waltons',
    timezone: 'Africa/Johannesburg',
    environment: GymEnvironment.Production,
    accountId: FB_PLATFORM_ACCOUNTID,
    organisation: Organisation.Bidvest,
    email: '',
    dummyPriceIdForSignup: WALTONS_PLAN_ID_FOR_USER_CREATION,
    subscribeNewUsersToPlanAfterFirstOnboarding: {
      planId: 'price_1OgPAfAcaWctOtVH8Q8tjwpL',
      coupon: '8rTceOno',
    },
    type: GymTypes.Indoor,
    numOfZones: 4,
    zoneMapping: [ [22,15,23], [5,11,21], [10,8,13], [3,7,14] ],
    autoCheckin: false,
    enableStudioAppCheckIn: true,
    enableStudioWeightRecommendations: true,
    publicHolidays: [],
    allowedOnProductIds: ['prod_PVQ0oLfJhrjV2H'],
    allowedCapacityAsPercentOfFullGym: 1,
    enabled: true,
    created: new Date('2024-02-07T11:22:21.741Z'),
  }),
  WaltonsStaging: new Gym({
    displayName: 'Waltons Staging',
    personalisedHeader: 'Bidvest Waltons Staging - powered by fitillion',
    landingPage: '',
    name: 'WaltonsStaging',
    timezone: 'Africa/Johannesburg',
    environment: GymEnvironment.Staging,
    accountId: FB_PLATFORM_ACCOUNTID,
    organisation: Organisation.FitillionPrivate,
    email: '',
    dummyPriceIdForSignup: WALTONS_PLAN_ID_FOR_USER_CREATION,
    subscribeNewUsersToPlanAfterFirstOnboarding: {
      planId: 'price_1OgkOjAcaWctOtVHRGXXj9mn',
      coupon: 'OngKqtut',
    },
    type: GymTypes.Indoor,
    numOfZones: 4,
    zoneMapping: [ [22,15,23], [5,11,21], [10,8,13], [3,7,14] ],
    autoCheckin: false,
    enableStudioAppCheckIn: true,
    enableStudioWeightRecommendations: true,
    publicHolidays: [],
    allowedOnProductIds: ['prod_PVlwZ7ocLayt09'],
    allowedCapacityAsPercentOfFullGym: 1,
    enabled: true,
    created: new Date('2024-02-07T11:22:21.741Z'),
  }),
  StudioTestStaging: new Gym({
    displayName: 'Studio Test Staging',
    landingPage: '',
    name: 'StudioTestStaging',
    timezone: 'Africa/Johannesburg',
    environment: GymEnvironment.Staging,
    accountId: FB_PLATFORM_ACCOUNTID,
    organisation: Organisation.Test,
    email: '',
    dummyPriceIdForSignup: PLATFORM_PLAN_ID_FOR_USER_CREATION,
    subscribeNewUsersToPlanAfterFirstOnboarding: {
      planId: 'price_1OgkOjAcaWctOtVHRGXXj9mn',
    },
    type: GymTypes.Indoor,
    numOfZones: 4 + (3 + 1 + 1 + 1 + 1),
    zoneMapping: [[22, 15, 23], [5, 11, 21], [10, 8, 13], [3, 7, 14], [100], [100], [100], [101], [102], [103], [104]],
    autoCheckin: false,
    enableStudioAppCheckIn: true,
    enableStudioWeightRecommendations: true,
    publicHolidays: [],
    allowedOnProductIds: ['prod_PVlwZ7ocLayt09'],
    allowedCapacityAsPercentOfFullGym: 1,
    enabled: true,
    created: new Date('2024-11-06T13:41:00.000Z'),
  }),
  // test the apps (on studio account specifically) when adding a new gym here
};

// todo: this must be used in DbGymRepository only. will be removed in #2426
export function loadTheHardcodedStaticGymConfig(environment?: GymEnvironment) {
  const copy = { ...gymConfig };
  if (environment) {
    for (const rawConfig of Object.values(copy)) {
      if (rawConfig.environment !== environment) {
        delete copy[rawConfig.name];
      }
    }
  }
  return copy;
}
